import { createGlobalStyle, CSSObject } from 'styled-components';

export const initialGlobalStyle = `
  main,
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  nav,
  section {
    display: block;
  }
  audio,
  canvas,
  video {
    display: inline-block;
    *display: inline;
    *zoom:1;
  }
  audio:not([controls]) {
    display: none;
  }
  [hidden] {
    display: none;
  }
  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }
  body {
    margin: 0;
    word-break: keep-all;
    color: #000;
  }
  body,
  button,
  input,
  select,
  textarea {
    font-family: 'Noto Sans KR',arial,sans-serif;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  a:focus {
    //outline: thin dotted;
    outline: 0;
  }
  a:hover,
  a:active {
    outline: 0;
  }
  b,
  strong {
    font-weight: bold;
  }
  blockquote {
    margin: 1em 40px;
  }
  dfn {
    font-style: italic;
  }
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #dadce0;
    margin: 20px 0;
    padding: 0;
  }
  ins {
    text-decoration: underline;
  }
  del {
    text-decoration: line-through;
  }
  mark {
    background: #ff0;
    font-style: italic;
  }
  pre,
  code,
  kbd,
  samp {
    font-family: monospace;
    _font-family: monospace;
    font-size: 1em;
  }
  pre {
    white-space: pre;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  p {
    margin: 0;
  }
  q {
    quotes: none;
  }
  q:before,
  q:after {
    content: "";
    content: none;
  }
  small {
    font-size: 85%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sup {
    top: -0.5em;
  }
  sub {
    bottom: -0.25em;
  }
  ul,
  ol {
    list-style: none;
    list-style-image: none;
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
  }
  dd {
    margin: 0;
  }
  img {
    display: inline-block;
    max-width: 100%;
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: top;
    height: auto;
    width: auto \\9;
  }
  svg:not(:root) {
    overflow: hidden;
  }
  figure {
    margin: 0;
  }
  form {
    margin: 0;
  }
  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
  }
  legend {
    display:none;
    border: 0;
    *margin-left: -7px;
    padding: 0;
  }
  label {
    cursor: pointer;
  }
  button,
  input,
  select,
  textarea {
    font-size: 100%;
    font-family: 'Noto Sans KR',arial,sans-serif;
    margin: 0;
    vertical-align: baseline;
    *vertical-align: middle;
    border-radius: 0;
    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, from(hsla(0,0%,100%,0)), to(hsla(0,0%,100%,0)));
    background-image: -webkit-linear-gradient(hsla(0,0%,100%,0), hsla(0,0%,100%,0));
  }
  button,
  input {
    line-height: normal;
    *overflow: visible;
  }
  table button,
  table input {
    *overflow: auto;
  }
  button,
  input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    cursor: pointer;
    -webkit-appearance: button;
  }
  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
  }
  input[type="search"] {
    -webkit-appearance: textfield;
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
  }
  input[type="number"]::-webkit-inner-spin-button{
    -webkit-appearance: none;
  }
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  textarea {
    overflow: auto;
    vertical-align: top;
    resize: vertical;
  }
  input:invalid,
  textarea:invalid {
    border-color: #C82E2D;
  }
  button[disabled],
  input[disabled] {
    cursor: default;
    // opacity: 0.5;
  }
  input:focus {
    outline: none;
  }
  input::-ms-clear {
    display: none;
  }
  /* Change the white to any color ;) */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  //select {
  //  -webkit-appearance: none;
  //  appearance: none;
  //}
  select::-ms-expand {
    display:none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  td {
    vertical-align: top;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
    margin: 0;
  }
  address,
  em,
  i {
    font-style: normal;
  }
  .clear {
    content: '';
    display: block;
    clear: both;
  }
  html {
    font-size: 14px;
    font-family: 'Noto Sans KR',arial,sans-serif;
    overflow-y: scroll;
  }
  .hidden {
    display: block;
    position: absolute;
    overflow: hidden;
    border: 0;
    width: 1px;
    height: 1px;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
  }
  html,
  body,
  #root {
    height: 100%;
  }
  &[role='tooltip'] {
    z-index: 1400;
  }

  /* Mui Skeleton */
  .MuiSkeleton-root::after{
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
  }

  .MuiSkeleton-wave {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.05);
  }`;

export const GlobalStyle = createGlobalStyle<CSSObject>`
  ${initialGlobalStyle}
`;
